import { PropertyFilterProps } from "@amzn/awsui-components-react/polaris/property-filter/interfaces";

export const convertTokensToPropertyFilter = (tokens: ReadonlyArray<PropertyFilterProps.Token>): { [key: string]: string[] } => {
    const result: { [key: string]: string[] } = {};

    tokens.forEach(i => {
        const key = i.propertyKey;
        if (!key) return;
        const value = typeof i.value === 'string' ? i.value.trim() : i.value;
        if (Object.keys(result).includes(key)) {
            result[key].push(value);
        } else {
            result[key] = [value];
        }
    });

    return result;
}
